export const isWorkspaceSettingsPath = (pathname: string): boolean =>
  /^\/workspaces\/[^/]+\/settings(\/|$)/.test(pathname);

export const resolveWorkspacePath = (path: string, workspaceId: string): string =>
  path.replace(":workspaceId", workspaceId);
